
// Import Vue
import Vue from 'vue';

import HighchartsVue from 'highcharts-vue';
Vue.use(HighchartsVue);

// Import Framework7
import Framework7 from 'framework7/framework7-lite.esm.bundle.js';

// Import Framework7-Vue Plugin
import Framework7Vue from 'framework7-vue/framework7-vue.esm.bundle.js';

// Import Dom7
import Dom7 from 'dom7/dist/dom7.js';

// Import Framework7 Styles
import 'framework7/css/framework7.bundle.css';

// Import Icons and App Custom Styles
import '../css/app.scss';

// Import App Custom Global Javascript
import './globalParam.js';
import './globalES.js';

import { addAssetsPublicPath } from '@/utils/env.js';

Vue.prototype.$ = ES;
Vue.prototype.g = g;
window.$$ = Dom7;
// Import App Component
import Other from '../components/other.vue';

// Init Framework7-Vue Plugin
Framework7.use(Framework7Vue);

// Init App
new Vue(Other).$mount('#other');

//animate lottie sample
$$('html').on('click', '#lottie-sample-ready',function () {
	lottieObj = lottie.loadAnimation({
		container: document.getElementById('lottie-sample'), 
		renderer: 'svg', 
		loop: true, 
		//loop: false, 
		autoplay: true, // 自動再生させないように
		//autoplay: false, // 自動再生させないように
		path: addAssetsPublicPath('static/1708-success.json')
	});
});

$$('html').on('click', '#lottie-sample-start',function () {
	console.log('lottieObj:',lottieObj);
	lottieObj.play();
});



//Ctrl
$$('html').on('click','.open-modal', function () {
	//$$( $$(this).attr('data-target') ).css('display','flex');
	$$( $$(this).attr('data-target') ).attr('data-visible','true');
});

$$('html').on('click','.close-modal', function () {
	//$$( $$(this).attr('data-target') ).css('display','none');
	$$( $$(this).attr('data-target') ).attr('data-visible','false');
});
